import axios from 'axios';
import api from './api';

export type GridKey = 'productos' | 'cotizaciones' | 'pedidos' | 'facturas' | 'recibos';

export type GridPreference = {
  visibleIds: string[];
  columnOrder: string[];
};

const pathFor = (gridKey: GridKey) => `/api/me/ui-preferences/grids/${gridKey}`;

const readIds = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((id): id is string => typeof id === 'string') : [];

const fromApi = (data: unknown): GridPreference => {
  const body = (data ?? {}) as Record<string, unknown>;
  return {
    visibleIds: readIds(body.visibleIds ?? body.VisibleIds),
    columnOrder: readIds(body.columnOrder ?? body.ColumnOrder),
  };
};

export async function getGridPreference(gridKey: GridKey): Promise<GridPreference | null> {
  try {
    const { data } = await api.get(pathFor(gridKey));
    return fromApi(data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) return null;
    throw error;
  }
}

export async function saveGridPreference(gridKey: GridKey, preference: GridPreference): Promise<void> {
  await api.put(pathFor(gridKey), preference);
}
